import React from 'react';
import RightMenuButton from './RightMenuButton';
import {connect} from 'react-redux';
import RightMenuDetails from './RightMenuDetails';
import {LanguageContext} from "../App";

class RightMenu extends React.Component {

    render() {
        return (
            <LanguageContext.Consumer>
                {({ language }) =>
                <div id="rightMenu">
                    <div id="rightMenuButtonsContainer"
                         className={this.props.isExpandedRightMenu.expanded ? 'expand-buttons-container' : ''}>
                        <RightMenuButton src={"/akademia/image/ico_konto.svg"} name={language["eksport"]} id='eksport'/>
                        <RightMenuButton src={"/akademia/image/ico_pomoc.svg"} name={language["pomoc"]} id='pomoc'/>
                        <RightMenuButton src={"/akademia/image/trasa_ico.svg"} name={language["zadania"]} id='scenariusze'/>
                    </div>
                    <RightMenuDetails setResetSimulator={this.props.setResetSimulator}/>
                </div>
                }
            </LanguageContext.Consumer>
        )
    }
}

export default connect(
    state => ({
        isExpandedRightMenu: state.expandRightMenu
    }),
    {})(RightMenu);



// WEBPACK FOOTER //
// ./src/RightMenu/RightMenu.js